<template>
    <div class="md-layout">
        <div class="md-layout-item md-size-100">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-yellow">
                    <div class="card-icon">
                        <md-icon>receipt</md-icon>
                    </div>
                    <h4 class="title">{{$t('menu.myorders')}}</h4>
                </md-card-header>
                <md-card-content>
                    <div v-if="!myOrders.length" class="spinner-wrapper">
                        <div v-if="isRunning">
                          
                            <md-progress-spinner class="md-accent" md-mode="indeterminate"></md-progress-spinner>
                        </div>
                      <div v-if="!isRunning">
                        Du har ingen ordrer i systemet
                      </div>
                    </div>
                   
                  <md-list class="md-hide-medium-and-up">
                    <template v-for="item in myOrders">
                      <md-list-item>
                        <div class="md-list-item-text">
                          <h3>{{ item.mys_extordernumber }} - {{ $t('pages.shipments.orderstatus.' + item.statecode) }}</h3>
                        </div>
                      </md-list-item>
                      <md-list-item v-if="item.mys_date">
                        <div class="md-list-item-text">
                          <template v-if="item.mys_date !== null">
                            {{ m(item.mys_date).format('ll') }}
                          </template>
                          <template v-if="item.mys_date_end !== null">
                                    - {{ m(item.mys_date_end).format('ll') }}
                                </template>
                        </div>
                      </md-list-item>
                      <md-list-item>
                        <div class="md-list-item-text">
                          <a v-bind:href="item.galleryUrl" target="_blank">
                            <md-button class="md-icon-button md-success mr-4">
                              <md-icon>picture_in_picture</md-icon>
                              {{$t('buttons.gallery_link')}}
                            </md-button></a>

                          <!--                                <a href="#" target="_blank" disabled>-->
                          <md-button class="md-icon-button md-disabled" disabled>
                            {{$t('buttons.edit_order')}}
                          </md-button>
                          <!--                                </a>-->
                        </div>
                      </md-list-item>
                      <md-divider></md-divider>
                    </template>

                  </md-list>

                  <span  class="md-small-hide">
                    <md-table v-model="myOrders"
                              md-sort="name"
                              md-sort-order="desc">
                        <md-table-row slot="md-table-row" slot-scope="{ item }">
                            <md-table-cell :md-label="$t('pages.shipments.orderid')" md-sort-by="mys_extordernumber">{{ item.mys_extordernumber }}</md-table-cell>
                            <md-table-cell :md-label="$t('pages.shipments.date')" md-sort-by="mys_date">
                                <template v-if="item.mys_date !== null">
                                    {{ m(item.mys_date).format('ll') }}
                                </template>

                                <template v-if="item.mys_date_end !== null">
                                    - {{ m(item.mys_date_end).format('ll') }}
                                </template>
                            </md-table-cell>
                            <md-table-cell :md-label="$t('pages.shipments.status')" md-sort-by="statecode">{{ $t('pages.shipments.orderstatus.' + item.statecode) }}</md-table-cell>

                            <md-table-cell>
                                <a v-bind:href="item.galleryUrl" target="_blank">
                                    <md-button class="md-icon-button md-success mr-4">
                                        <md-icon>picture_in_picture</md-icon>
                                        {{$t('buttons.gallery_link')}}
                                    </md-button></a>

<!--                                <a href="#" target="_blank" disabled>-->
                                    <md-button class="md-icon-button md-disabled" disabled>
                                        {{$t('buttons.edit_order')}}
                                    </md-button>
<!--                                </a>-->

                            </md-table-cell>
                        </md-table-row>
                    </md-table>
                    </span>
                </md-card-content>
            </md-card>
        </div>
    </div>
</template>

<script>
    import apiService from '../../../services/APIService';
    import moment from 'moment'
    import { mapGetters } from 'vuex';

    moment.locale('da-DK');

    export default {
        components: {},
        data() {
            return {
              isRunning : false,
                m: moment,
                myOrders: []
            };
        },
        computed:{
            ...mapGetters(["activeAccount"])
        },
        created() {
            this.init();
        },
        methods:{
            init(){
              this.isRunning = true;
                apiService.getApi(`/portals/v1/user/orders`).then(response => {
                  this.isRunning = false;
                    this.myOrders = response.data;
                })
                .catch(() => this.isRunning = false);

                var d = new Date();
                d.setTime(d.getTime() + (2*24*60*60*1000));
                var expires = "expires="+ d.toUTCString();
                document.cookie = "mys_user=true; " + expires + "; domain=.myselfie.com";
            }
        }
    };
</script>
<style>
    .md-table-head-container
    {
        font-weight: bold !important;
    }
    
    .spinner-wrapper{
        display:flex;
        justify-content: center;
    }
</style>
